import React, { memo } from "react";
import { useTranslation } from "react-i18next";
import { Typography } from "@mui/material";
import { MdCheck } from "@react-icons/all-files/md/MdCheck";
import { Connector, Container, ProgressIcon, Step } from "./wizardSteps.styles";

interface IWizard {
  step: number;
}

function Wizard({ step }: IWizard) {
  const { t } = useTranslation();
  return (
    <Container>
      <Connector />
      <ProgressIcon>
        <Step id={"step1"} isActive={step >= 1}>
          {step > 1 ? <MdCheck size={25} /> : "1"}
        </Step>
        <Typography
          variant="subtitle2"
          sx={{ mt: 1.25 }}
          color={step === 1 ? "#333333" : "#999999"}
        >
          {t("basic_details", { defaultValue: "Basic Details" })}
        </Typography>
      </ProgressIcon>
      <ProgressIcon>
        <Step id={"step2"} isActive={step >= 2}>
          {step > 2 ? <MdCheck size={25} /> : "2"}
        </Step>
        <Typography
          variant="subtitle2"
          sx={{ mt: 1.25 }}
          color={step === 2 ? "#333333" : "#999999"}
        >
          {t("bank_details", { defaultValue: "Bank Details" })}
        </Typography>
      </ProgressIcon>
      <ProgressIcon>
        <Step id={"step3"} isActive={step >= 3}>
          {step > 3 ? <MdCheck size={25} /> : "3"}
        </Step>
        <Typography
          variant="subtitle2"
          sx={{ mt: 1.25 }}
          color={step === 3 ? "#333333" : "#999999"}
        >
          {t("confirm_details", { defaultValue: "Confirm Details" })}
        </Typography>
      </ProgressIcon>
    </Container>
  );
}

export default memo(Wizard);
